import { TaxYearsLimitsIRS } from '../types';

export const combineLimits = (...limits: TaxYearsLimitsIRS[]): TaxYearsLimitsIRS => {
  const result: TaxYearsLimitsIRS = {};

  for (const limitObj of limits) {
    if (!limitObj) continue;

    for (const taxYear in limitObj) {
      if (!result[taxYear]) {
        result[taxYear] = {};
      }

      const employeeLimits = limitObj[taxYear];
      for (const employeeId in employeeLimits) {
        if (!result[taxYear][employeeId]) {
          result[taxYear][employeeId] = {};
        }

        const planLimits = employeeLimits[employeeId];
        for (const planId in planLimits) {
          result[taxYear][employeeId][planId] = planLimits[planId];
        }
      }
    }
  }

  return result;
};
